import BookingList from "./components/BookingList";
import Breadcrumb from "./components/Breadcrumb";

function MyBooking() {
    return (
        <>
        <Breadcrumb />
        <BookingList />
        </>
    );
}
export default MyBooking;